'use client'
import useIsMounted from '@/hooks/useIsMounted'

import dynamic from 'next/dynamic'
import animationData from '../../public/loading.json'

const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

interface Props {
  additionalClasses?: string
}

const Loading = ({ additionalClasses }: Props) => {
  const isMounted = useIsMounted()
  return (
    <div className={`loading ${additionalClasses}`}>
      {isMounted && <Lottie animationData={animationData} />}
    </div>
  )
}

export default Loading
